import React, { useEffect, useRef, useState } from 'react'
import './ProfilePage.css'
import SaveIcon from '../../assets/profile/saveIcon.svg'
import Settings from '../../assets/profile/settingsIcon.svg'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment';
import { get_all_events } from '../../Api/homeapi'
import ProfilePagePost from '../Components/ProfilePagePost'
import ListItem from '@mui/material/ListItem';
import { FixedSizeGrid } from 'react-window';
import { Link, useNavigate } from 'react-router-dom'
import { getFollowersAndFollowing } from '../../Api/Flask/userapis'
import { getUserData } from '../../Api/firebaseAPis'
import GifLoader from '../Components/GifLoader'

function ProfilePage() {
  const [upcomingClass, setUpcomingClass] = useState("selected-tab tab")
  const [recentClass, setRecentClass] = useState("tab")
  const [follower, setFollower] = useState(0)
  const [following, setFollowing] = useState(0)

  const eventDataMain = useSelector(state => state.Event).eventData
  const userData = useSelector(state => state.Event).user
  const [createdEvent, setcreatedEvent] = useState({})
  const [invitedEvents, setinvitedEvents] = useState({})
  const [eventData, setEventData] = useState({})
  const [allFF, setFF] = useState({})
  const [loader, setLoader] = useState(false)
  const [itemCount, setItemCount] = useState(2)
  const uid = localStorage.getItem('uid')
  const windowSize = useRef([window.innerWidth, window.innerHeight]);
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    getAsyncData()
  }, [])

  const followingData = useSelector((state) => state.Event).followingData;
  const followerData = useSelector((state) => state.Event).allfollowerdata;

  const showFollowingFollower = () => {
    console.log(followerData)
    setFollowing(Object.keys(followingData ? followingData : {}).length)
    setFollower(Object.keys(followerData ? followerData : {}).length)
  }


  useEffect(() => {
    showFollowingFollower()
  }, [followingData, followerData])

  const sortData = (all_events) => {
    var postX = Object.keys(all_events).map(function (key) {
      all_events[key]['data']['id'] = key;
      return all_events[key]['data'];
    });
    if (postX.length === 0) {
      setEventData([]);
    } else {
      setEventData(postX.reverse());
    }
    let cEvents = [];
    let iEvents = [];
    for (var i in postX) {
      if (postX[i].author === uid) {

        cEvents.push(postX[i]);
      } else {
        iEvents.push(postX[i]);
      }
    }
    if (cEvents.length > 0) {

      setItemCount(cEvents.length)
      setcreatedEvent(cEvents);
    }
    if (iEvents.length > 0) {

      setinvitedEvents(iEvents);
    }
  }

  const getAsyncData = async () => {
    setLoader(true)
    const uid = localStorage.getItem('uid')
    const user = await getUserData(uid)
    dispatch({
      type: 'SET_USER',
      user: user
    })
    const all_events = await get_all_events(uid)
    const action = {
      type: 'SET_EVENT_DATA',
      eventData: all_events
    }
    let allFF = await getFollowersAndFollowing({ uid: uid })
    setFF(allFF)
    dispatch(action)
    sortData(all_events)
    setLoader(false)
  }

  const onclick = () => {

    setUpcomingClass("selected-tab tab")
    setRecentClass("tab")
    setItemCount(createdEvent.length)
    setEventData(createdEvent)
  }

  const clickRecent = () => {

    setRecentClass("selected-tab tab")
    setUpcomingClass("tab")

    setItemCount(invitedEvents.length)
    setEventData(invitedEvents)
  }

  function renderRow(props) {
    const { columnIndex, rowIndex, style } = props;
    const currentIndex = rowIndex * 2 + columnIndex
    return (
      <ListItem style={style}>
        <ProfilePagePost data={props.data ? eventData[props.data[currentIndex]] : ""} id={props.data ? props.data[currentIndex] : ""} />
      </ListItem>
    );
  }

  return (
    <>
      {loader ? <GifLoader /> :
        <div className='w-full mx-auto'>
          <div className='top__section--profile'>
            {/* //////////////////////////// */}
            {/* Top Section */}
            {/* //////////////////////////// */}
            <div className='top__profile'>
              <div style={{ display: 'flex', gap: 10 }}>
                <div>
                  <img style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: "50%", border: "5px solid #0a0a0a" }} src={process.env.PUBLIC_URL + '/icon.jpg'} />
                </div>
                <div style={{ textAlign: 'left', marginTop: 10 }}>
                  <h3 style={{ fontSize: 16 }}>{userData ? `${userData.firstname} ${userData.lastname}` : ""}</h3>
                  <p style={{ fontSize: 14 }}>{userData ? userData.username : ""}</p>
                  <h5 style={{ textDecoration: 'underline' }}>Edit Profile</h5>
                </div>
              </div>
              <div style={{ textAlign: 'left', marginTop: 10, display: 'flex', gap: 5, alignItems: 'flex-start' }}>
                <div>
                  <img src={SaveIcon} />
                </div>
                <div onClick={() => {
                  navigate('/settings')
                }
                }>
                  <img src={Settings} />
                </div>

              </div>
            </div>
            {/* //////////////////////////// */}
            {/* Following Section */}
            {/* //////////////////////////// */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ display: 'column' }}>
                <div>
                  <Link to="/follower">

                    <p>{follower}</p>
                    <p>Followers</p>
                  </Link>
                </div>
              </div>
              <div style={{
                height: 50,
                border: '1px solid #eaeaea',
                marginLeft: 20,
                marginRight: 20
              }}></div>
              <div style={{ display: 'column' }}>

                <Link to="/following">
                  <p>{following}</p>
                  <p>Following</p>
                </Link>

              </div>
            </div>
          </div>
          <div>
            <div className='row center gap-top gap-bottom'>
              <div className={upcomingClass} onClick={() => onclick()}>
                Created
              </div>
              <div className={recentClass} onClick={() => clickRecent()}>
                Invited
              </div>
            </div>

            <div>
              <FixedSizeGrid
                columnCount={itemCount > 1 ? 2 : 1}
                columnWidth={windowSize.current[0] / 2}
                height={1000}
                rowCount={upcomingClass === "selected-tab tab" ? Object.keys(createdEvent).length / 2 : Object.keys(invitedEvents).length / 2}
                rowHeight={200}
                width={windowSize.current[0]}
                itemCount={upcomingClass === "selected-tab tab" ? Object.keys(createdEvent).length : Object.keys(invitedEvents).length}
                overscanCount={2}
                itemData={upcomingClass === "selected-tab tab" ? Object.keys(createdEvent) : Object.keys(invitedEvents)}
              >
                {renderRow}
              </FixedSizeGrid>
            </div>


          </div>
        </div>
      }
    </>
  )
}

export default ProfilePage